// extracted by mini-css-extract-plugin
module.exports = {"MogulPersonContainerMob":"style_MogulPersonContainerMob__qjgu9","MogulPersonMob":"style_MogulPersonMob__2YqP4"};